import script from "./QTLiteRowCells.vue?vue&type=script&setup=true&lang=ts"
export * from "./QTLiteRowCells.vue?vue&type=script&setup=true&lang=ts"

import "./QTLiteRowCells.vue?vue&type=style&index=0&id=cc288f86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc288f86"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QCard});
